import { c as _c } from "react/compiler-runtime";
import { LinkButton } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
export type BosListItemProps = {
  name: string;
  isCurrentBo: boolean;
  ownershipStake: number;
  onEdit: () => void;
};
export const BosListItem = t0 => {
  const $ = _c(20);
  const {
    name,
    isCurrentBo,
    ownershipStake,
    onEdit
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectBusinessData.beneficialOwners.list"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($[1] !== isCurrentBo || $[2] !== t) {
    t2 = isCurrentBo && <span>{t(_temp)}</span>;
    $[1] = isCurrentBo;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== name || $[5] !== t2) {
    t3 = <span className="text-label-2 text-primary">{name}{t2}</span>;
    $[4] = name;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== ownershipStake || $[8] !== t) {
    t4 = t(_temp2, {
      stake: ownershipStake
    });
    $[7] = ownershipStake;
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <span className="text-caption-1 text-tertiary">{t4}</span>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t5) {
    t6 = <div className="flex flex-col gap-1">{t3}{t5}</div>;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== onEdit) {
    t7 = <LinkButton variant="label-2" onClick={onEdit}>Edit</LinkButton>;
    $[15] = onEdit;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = <div className="flex justify-between items-center">{t6}{t7}</div>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};
function _temp($) {
  return $.you;
}
function _temp2($_0) {
  return $_0["owns-stake"];
}